// @flow

import classNames from 'classnames';
import React from 'react';
import type { Node } from 'react';
import { Row, Col } from '@riseart/antd-provider';
import { Heading, Link } from '@riseart/common';
import { Section, Wrapper } from '@riseart/layout';
import { LocalizedConfig } from 'shared_services/riseart/utils/LocalizedConfig';
import { ReviewsLogo } from 'shared_components/arts/reviews/Logo';

import {
  notFoundCls,
  notFoundTitleCls,
  notFoundSubtitleCls,
  notFoundContentCls,
  notFoundReviewCls,
  notFoundFooterCls,
  notFoundLeftCls,
  notFoundRightCls,
} from 'shared_components/common/notfound/Content.less';

type Props = {
  className?: string,
  title?: Node,
  subtitle?: Node,
  content?: Node,
  message?: Node,
  footer?: Node,
  image?: Node,
};

/**
 * NotFoundContent
 *
 * @param {Props} props
 * @returns {Node}
 */
export function NotFoundContent({
  className = null,
  title,
  subtitle,
  content,
  message,
  footer,
  image,
}: Props): Node {
  return (
    <Section className={classNames(notFoundCls, className)}>
      <Wrapper
        sizes={{
          xs: 'wide',
          sm: 'wide',
          md: 'wide',
          lg: 'narrow',
          xl: 'narrow',
        }}
      >
        <Row type="flex" justify="space-between">
          <Col span={24} md={11} lg={11} className={notFoundLeftCls}>
            {image}
          </Col>
          <Col span={24} md={12} className={notFoundRightCls}>
            {title ? (
              <Heading tag="h2" level="3" className={notFoundTitleCls}>
                {title}
              </Heading>
            ) : null}
            {subtitle ? <div className={notFoundSubtitleCls}>{subtitle}</div> : null}
            {content ? <div className={notFoundContentCls}>{content}</div> : null}
            <div className={notFoundReviewCls}>
              <span>{message || null}</span>
              <div>
                <Link
                  external
                  type="light"
                  href={LocalizedConfig.get('externalUrls.companyReviews')}
                  title=""
                  target="_blank"
                >
                  <ReviewsLogo align="vertical" />
                </Link>
              </div>
            </div>
            {footer ? <div className={notFoundFooterCls}>{footer}</div> : null}
          </Col>
        </Row>
      </Wrapper>
    </Section>
  );
}
